'use client'

import { useTranslations } from 'next-intl'
import { ComponentProps, useState } from 'react'

import { cn } from '@/shared/lib'
import { Icon, TextButton } from '@/shared/ui'

type UseExpandProps = {
  defaultExpanded?: boolean
}

export const useExpand = ({ defaultExpanded = false }: UseExpandProps = {}) => {
  const [expanded, setExpanded] = useState(defaultExpanded)

  const toggleExpand = () => {
    setExpanded(prevExpanded => !prevExpanded)
  }

  return { expanded, toggleExpand }
}

type ButtonProps = ComponentProps<typeof TextButton> & {
  expanded: boolean
  onClick: () => void
}

export const ExpandButton = ({
  expanded,
  onClick,
  className,
  ...restProps
}: ButtonProps) => {
  const t = useTranslations('filter')

  return (
    <TextButton
      onClick={onClick}
      color="gray"
      size="large"
      className={cn('gap-0', className)}
      {...restProps}
    >
      {expanded ? t('button.fold') : t('button.more')}
      <Icon
        name="arrow-bottom"
        size={16}
        className={cn(
          'gap-0 transition-transform duration-300',
          expanded && 'rotate-180',
        )}
      />
    </TextButton>
  )
}
